function WowzaWebRTCPlaybackPlayer(wowzaApplicationName, wowzaStreamlock, streamName, videoElementId, callback) {
    let applicationName = wowzaApplicationName;
    const wssUrl = `wss://${wowzaStreamlock}/webrtc-session.json`;
    let wsConnection, videoElement = null;
    let retry = 0;
    const maxRetry = 120;
    let peerConnection = null;

    const wsConnect = () => {
        let streamInfo = { applicationName, streamName };
        let userData = {};

        try {
            wsConnection = new WebSocket(wssUrl);
        } catch (e) {
        }
        wsConnection.binaryType = "arraybuffer";

        wsConnection.onopen = () => {
            peerConnection = new RTCPeerConnection();

            peerConnection.onicecandidate = gotIceCandidate;
            peerConnection.onconnectionstatechange = onConnStateChange;

            peerConnection.ontrack = (event) => {
                videoElement = document.getElementById(videoElementId);
                videoElement.muted = true;
                videoElement.srcObject = event.streams[0];
                videoElement.addEventListener('canplaythrough', () => {
                    videoElement.play();
                });
            };
            sendPlayGetOffer();
        };

        wsConnection.onerror = (error) => {
            retryConnection();
        };

        function onConnStateChange(event) {
            callback.handlePeerConnectionStatus(event.currentTarget.connectionState);
        }

        function retryConnection() {
            if (retry < maxRetry) {
                retry++;
                wsConnect();
            } else {
                console.error("Max retry limit reached, unable to establish connection.");
            }
        }

        function gotIceCandidate(event) {
            if (event.candidate && wsConnection && wsConnection.readyState === WebSocket.OPEN) {
                wsConnection.send(JSON.stringify({
                    direction: "play",
                    command: "sendCandidate",
                    candidate: event.candidate
                }));
            }
        }

        function sendPlayGetOffer() {
            if (wsConnection && wsConnection.readyState === WebSocket.OPEN) {
                wsConnection.send(JSON.stringify({
                    direction: "play",
                    command: "getOffer",
                    streamInfo: streamInfo,
                    userData: userData
                }));
            }
        };

        this.stop = function stop() {
            if (peerConnection != null) {
                peerConnection.getSenders().forEach(sender => peerConnection.removeTrack(sender));
                peerConnection.getTransceivers().forEach(transceiver => transceiver.stop());
                peerConnection.onconnectionstatechange = null;
                peerConnection.close();
            }
            peerConnection = null;
            
            if (wsConnection != null) {
                wsConnection.onerror = null;
                wsConnection.close(1000, "Normal closure");
            }
            wsConnection = null;

            videoElement = document.getElementById(videoElementId);
            if (videoElement) {
                videoElement.src = "";
                videoElement.srcObject = null;
            }
        }

        this.SendPlayGetOffer = function SendPlayGetOffer() {
            sendPlayGetOffer();
        }

        wsConnection.onmessage = function (evt) {
            let msgJSON = JSON.parse(evt.data);
            const msgStatus = Number(msgJSON.status);
            const msgCommand = msgJSON.command;

            callback.handleWebSocketStatus(msgStatus);

            if (msgStatus != 200) {
                retry++;
                if (retry < maxRetry) {
                    sendPlayGetOffer();
                }
            } else {
                retry = 0;
                let streamInfoResponse = msgJSON.streamInfo;
                if (streamInfoResponse !== undefined) {
                    streamInfo.sessionId = streamInfoResponse.sessionId;
                }

                let sdpData = msgJSON.sdp;
                if (sdpData != null) {

                    if (mungeSDP != null) {
                        msgJSON.sdp.sdp = mungeSDP(msgJSON.sdp.sdp);
                    }

                    // Enhance here if Safari is a published stream.
                    peerConnection
                        .setRemoteDescription(new RTCSessionDescription(msgJSON.sdp))
                        .then(() => peerConnection
                            .createAnswer()
                            .then((description) => {
                                peerConnection
                                    .setLocalDescription(description)
                                    .then(() => {
                                        wsConnection.send(
                                            '{"direction":"play", "command":"sendResponse", "streamInfo":' +
                                            JSON.stringify(streamInfo) +
                                            ', "sdp":' +
                                            JSON.stringify(
                                                description
                                            ) +
                                            ', "userData":' +
                                            JSON.stringify(userData) +
                                            "}"
                                        );
                                    })
                                    .catch((err) => {});
                            })
                        )
                        .catch((err) => {});
                }

                let iceCandidates = msgJSON.iceCandidates;
                if (iceCandidates != null) {
                    for (let index in iceCandidates) {
                        peerConnection.addIceCandidate(new RTCIceCandidate(iceCandidates[index]));
                    }
                }
            }

            /** This particular code is creating issues for disconnecting the streams */
            // if ("sendResponse".localeCompare(msgCommand) == 0) {
            //     if (wsConnection != null) {
            //         wsConnection.close(1000, "Normal closure");
            //     }
            //     wsConnection = null;
            // }
        };

        wsConnection.onclose = (evt) => {};
    };


    const mungeSDP = (sdpStr) => {
        // For greatest playback compatibility,
        // force H.264 playback to baseline (42e01f).
        let sdpLines = sdpStr.split(/\r\n/);
        let sdpStrRet = "";

        for (let sdpIndex in sdpLines) {
            let sdpLine = sdpLines[sdpIndex];

            if (sdpLine.length == 0) continue;

            if (sdpLine.includes("profile-level-id")) {
                // The profile-level-id string has three parts: XXYYZZ, where
                //   XX: 42 baseline, 4D main, 64 high
                //   YY: constraint
                //   ZZ: level ID
                // Look for codecs higher than baseline and force downward.
                let profileLevelId = sdpLine.substr(
                    sdpLine.indexOf("profile-level-id") + 17,
                    6
                );
                let profile = Number("0x" + profileLevelId.substr(0, 2));
                let constraint = Number("0x" + profileLevelId.substr(2, 2));
                let level = Number("0x" + profileLevelId.substr(4, 2));
                if (profile > 0x42) {
                    profile = 0x42;
                    constraint = 0xe0;
                    level = 0x1f;
                }
                let newProfileLevelId =
                    ("00" + profile.toString(16)).slice(-2).toLowerCase() +
                    ("00" + constraint.toString(16)).slice(-2).toLowerCase() +
                    ("00" + level.toString(16)).slice(-2).toLowerCase();

                sdpLine = sdpLine.replace(profileLevelId, newProfileLevelId);
            }

            sdpStrRet += sdpLine;
            sdpStrRet += "\r\n";
        }

        return sdpStrRet;
    };

    /* initialize and play, wire in play button here */

    if (applicationName == "" || streamName == "" || wssUrl == "") {
        alert("Please fill out the connection details");
    } else {
        wsConnect();
    }
}
